<template>
    <div class="rule-form-wrap">
        <el-form :class="{'rule-form': true, 'rule-form-search': search }" ref="ruleDom" :model="form" :rules="rule">
            <template v-for="item in meta">

                <!--            分组样式-->
                <el-form-item v-if="item.fieldOrigin == 0" class="rule-form-title" :key="item.fieldModelId">{{item.fieldName}}</el-form-item>

                <!--            占位符-->
                <el-form-item v-else-if="item.fieldOrigin == 3" class="flex-item item-empty" :key="item.fieldModelId" />

                <!--             只读模式-->
                <!--   <template v-else-if="readOnly && item.fieldNeedInput"> 非采集字段详情下不显示 -->
                <template v-else-if="readOnly">
                    <!--            脱敏字段-->
                    <el-form-item v-if="item.fieldDesensitive" :class="{ 'flex-item': true,  'read-only': true, 'item-block': item.fieldInputType == 5 }" :title="item.fieldName" :label="item.fieldName" :key="item.fieldModelId">
                        <j-sensitive v-if="item.fieldInputType == 1 && item.fieldDicKeyInputFormat === 2" :rule="[3, -4]" :value="form[item.fieldEng]" eye />
                        <j-sensitive v-else :rule="desensitiveRule[item.fieldEng]" :value="form[item.fieldEng]" eye />
                    </el-form-item>

                    <!--            文本/数字/时间单项-->
                    <el-form-item v-else-if="item.fieldInputType == 1 || item.fieldInputType == 2 || item.fieldInputType == 4 || item.fieldInputType == 14 || item.fieldInputType == 15 || item.fieldInputType == 17" class="flex-item read-only" :title="item.fieldName" :label="item.fieldName" :key="item.fieldModelId">
                        <span class="flex-item-text">{{form[item.fieldEng]}}</span>
                    </el-form-item>

                    <!--            文本域-->
                    <el-form-item v-else-if="item.fieldInputType == 5" class="flex-item item-block read-only" :title="item.fieldName" :label="item.fieldName" :key="item.fieldModelId">
                        <span class="flex-item-text">{{form[item.fieldEng]}}</span>
                    </el-form-item>

                    <!--            单选框-->
                    <el-form-item v-else-if="item.fieldInputType == 6 || item.fieldInputType == 8" class="flex-item read-only" :title="item.fieldName" :label="item.fieldName" :prop="item.fieldEng" :key="item.fieldModelId">
                        <!--        字典项-->
                        <span v-if="item.fieldDicKeyInputFormat == 1" class="flex-item-text">
                            <j-dictionary :code="item.fieldDicKey" :api="`/api/dictionaryItems/${item.fieldDicKey}/negot-items`" :value="form[item.fieldEng]"/>
                        </span>
                        <!--        用户管理-->
                        <span  v-else class="flex-item-text">
                            {{userMap[form[item.fieldEng]]}}
                        </span>
                    </el-form-item>

                    <!--            多选框-->
                    <el-form-item v-else-if="item.fieldInputType == 7 ||item.fieldInputType == 9 " class="flex-item read-only" :title="item.fieldName" :label="item.fieldName" :key="item.fieldModelId">
                        <!--        字典项-->
                        <span v-if="item.fieldDicKeyInputFormat == 1" class="flex-item-text">
                            <j-dictionary class="flex-item-text-item" v-for="field in form[item.fieldEng]" :key="field" :code="item.fieldDicKey" :api="`/api/dictionaryItems/${item.fieldDicKey}/negot-items`" :value="field"/>
                        </span>
                        <!--        用户管理-->
                        <span  v-else class="flex-item-text">
                            <span class="flex-item-text-item" v-for="field in form[item.fieldEng]" :key="field">{{userMap[field]}}</span>
                        </span>
                    </el-form-item>

                    <!--            时间范围-->
                    <el-form-item v-else-if="item.fieldInputType == 3" class="flex-item item-block read-only" :title="item.fieldName" :label="item.fieldName" :key="item.fieldModelId">
            <span class="flex-item-text">
              {{form[item.fieldEng]}}
            </span>
                    </el-form-item>

                    <!--            地址选择器-->
                    <el-form-item v-else-if="item.fieldInputType == 11" class="flex-item read-only" :title="item.fieldName" :label="item.fieldName" :key="item.fieldModelId">
                        <j-address v-if="form[item.fieldEng]" type="text" v-model="form[item.fieldEng]" value-type="String" :emitPath="false" />
                    </el-form-item>

                    <!--            所属区划选择器-->
                    <el-form-item v-else-if="item.fieldInputType == 12" class="flex-item read-only" :title="item.fieldName" :label="item.fieldName" :key="item.fieldModelId">
                        <j-grid-ctrl v-if="form[item.fieldEng]" v-model="form[item.fieldEng]" :rule="[6, 9, 12, 14]" />
                    </el-form-item>

                    <!--            所属机构选择器-->
                    <el-form-item v-else-if="item.fieldInputType == 13" class="flex-item read-only" :title="item.fieldName" :label="item.fieldName" :key="item.fieldModelId">
                        <span v-if="form[item.fieldEng]" class="flex-item-text">{{$store.state.orgMap[form[item.fieldEng]]}}</span>
                    </el-form-item>

                    <el-form-item v-else-if="item.fieldInputType == 18" class="flex-item read-only" :title="item.fieldName" :label="item.fieldName" :key="item.fieldModelId">
                        <j-upload v-if="form[item.fieldEng]" v-model="form[item.fieldEng]" mode="card" read-only />
                    </el-form-item>

                    <!--            未匹配-->
                    <el-form-item v-else class="flex-item read-only" :title="item.fieldName" :label="item.fieldName" :key="item.fieldModelId">
                        <span class="flex-item-warn">自定义字段:{{ item.fieldName }},未设置类型</span>
                    </el-form-item>

                </template>

                <!--            需要采集字段/搜索模式下可以查询非采集字段-->
                <template v-else-if="item.fieldNeedInput || (!item.fieldNeedInput && search)">

                    <!--            就业情况特殊逻辑处理开始-->

                    <el-form-item v-if="item.fieldEng === 'employment'" :class="{'flex-item': true, 'flex-search': search }" :title="item.fieldName" :label="item.fieldName" :prop="item.fieldEng" :key="item.fieldModelId">
                        <!--        是否就业-->
                        <j-dictionary type="checkbox" v-model="form[item.fieldEng]" :code="item.fieldDicKey" :api="`/api/dictionaryItems/${item.fieldDicKey}/negot-items`" :placeholder="`请选择${item.fieldName}`" :disabled="item.autoGenerate == 'true'" @change="employmentChange(item.fieldEng)" />
                    </el-form-item>

                    <el-form-item v-else-if="item.fieldEng === 'country_recruit'" :class="{'flex-item': true, 'flex-search': search }" :title="item.fieldName" :label="item.fieldName" :prop="item.fieldEng" :key="item.fieldModelId">
                        <!--        农业一线招工-->
                        <j-dictionary type="checkbox" v-model="form[item.fieldEng]" :code="item.fieldDicKey" :api="`/api/dictionaryItems/${item.fieldDicKey}/negot-items`" :placeholder="`请选择${item.fieldName}`" :disabled="form['employment'] == 'false'" @change="employmentChange(item.fieldEng)" />
                    </el-form-item>

                    <el-form-item v-else-if="item.fieldEng === 'country_land_auth'" :class="{'flex-item': true, 'flex-search': search }" :title="item.fieldName" :label="item.fieldName" :prop="item.fieldEng" :key="item.fieldModelId">
                        <!--        农业一线土地确权-->
                        <j-dictionary type="checkbox" v-model="form[item.fieldEng]" :code="item.fieldDicKey" :api="`/api/dictionaryItems/${item.fieldDicKey}/negot-items`" :placeholder="`请选择${item.fieldName}`" :disabled="form['country_recruit'] !== ''" />
                    </el-form-item>

                    <el-form-item v-else-if="item.fieldEng === 'industry'" :class="{'flex-item': true, 'flex-search': search }" :title="item.fieldName" :label="item.fieldName" :prop="item.fieldEng" :key="item.fieldModelId">
                        <!--        所属产业-->
                        <j-dictionary type="select" v-if="item.fieldDicKeyInputFormat == 1" v-model="form[item.fieldEng]" :code="item.fieldDicKey" :api="`/api/dictionaryItems/${item.fieldDicKey}/negot-items`" :placeholder="`请选择${item.fieldName}`" :disabled="form['country_recruit'] == 'true'" @change="industryChange" />
                    </el-form-item>

                    <!--          从业  -->
                    <el-form-item v-else-if="item.fieldEng === 'talent_industry1_praction'" :class="{'flex-item': true, 'flex-search': search }" :title="item.fieldName" :label="item.fieldName" :prop="item.fieldEng" :key="item.fieldModelId">
                        <!--        一产从业-->
                        <j-dictionary type="select" v-if="item.fieldDicKeyInputFormat == 1" v-model="form[item.fieldEng]" :code="item.fieldDicKey" :api="`/api/dictionaryItems/${item.fieldDicKey}/negot-items`" :placeholder="`请选择${item.fieldName}`" :disabled="!(form['industry'] == 1 && form['employment'] == 'true')" />
                    </el-form-item>
                    <el-form-item v-else-if="item.fieldEng === 'talent_industry2_praction'" :class="{'flex-item': true, 'flex-search': search }" :title="item.fieldName" :label="item.fieldName" :prop="item.fieldEng" :key="item.fieldModelId">
                        <!--        二产从业-->
                        <j-dictionary type="select" v-if="item.fieldDicKeyInputFormat == 1" v-model="form[item.fieldEng]" :code="item.fieldDicKey" :api="`/api/dictionaryItems/${item.fieldDicKey}/negot-items`" :placeholder="`请选择${item.fieldName}`" :disabled="!(form['industry'] == 2 && form['employment'] == 'true')" />
                    </el-form-item>
                    <el-form-item v-else-if="item.fieldEng === 'talent_industry3_praction'" :class="{'flex-item': true, 'flex-search': search }" :title="item.fieldName" :label="item.fieldName" :prop="item.fieldEng" :key="item.fieldModelId">
                        <!--        三产从业-->
                        <j-dictionary type="select" v-if="item.fieldDicKeyInputFormat == 1" v-model="form[item.fieldEng]" :code="item.fieldDicKey" :api="`/api/dictionaryItems/${item.fieldDicKey}/negot-items`" :placeholder="`请选择${item.fieldName}`" :disabled="!(form['industry'] == 3 && form['employment'] == 'true')" />
                    </el-form-item>

                    <!--          随迁 -->
                    <el-form-item v-else-if="item.fieldEng === 'talent_industry1_trailing'" :class="{'flex-item': true, 'flex-search': search }" :title="item.fieldName" :label="item.fieldName" :prop="item.fieldEng" :key="item.fieldModelId">
                        <!--        一产随迁-->
                        <j-dictionary type="select" v-if="item.fieldDicKeyInputFormat == 1" v-model="form[item.fieldEng]" :code="item.fieldDicKey" :api="`/api/dictionaryItems/${item.fieldDicKey}/negot-items`" :placeholder="`请选择${item.fieldName}`" :disabled="!(form['industry'] == 1 && form['employment'] == 'false')" />
                    </el-form-item>
                    <el-form-item v-else-if="item.fieldEng === 'talent_industry2_trailing'" :class="{'flex-item': true, 'flex-search': search }" :title="item.fieldName" :label="item.fieldName" :prop="item.fieldEng" :key="item.fieldModelId">
                        <!--        二产随迁-->
                        <j-dictionary type="select" v-if="item.fieldDicKeyInputFormat == 1" v-model="form[item.fieldEng]" :code="item.fieldDicKey" :api="`/api/dictionaryItems/${item.fieldDicKey}/negot-items`" :placeholder="`请选择${item.fieldName}`" :disabled="!(form['industry'] == 2 && form['employment'] == 'false')" />
                    </el-form-item>
                    <el-form-item v-else-if="item.fieldEng === 'talent_industry3_trailing'" :class="{'flex-item': true, 'flex-search': search }" :title="item.fieldName" :label="item.fieldName" :prop="item.fieldEng" :key="item.fieldModelId">
                        <!--        三产随迁-->
                        <j-dictionary type="select" v-if="item.fieldDicKeyInputFormat == 1" v-model="form[item.fieldEng]" :code="item.fieldDicKey" :api="`/api/dictionaryItems/${item.fieldDicKey}/negot-items`" :placeholder="`请选择${item.fieldName}`" :disabled="!(form['industry'] == 3 && form['employment'] == 'false')" />
                    </el-form-item>



                    <!--            就业情况特殊逻辑处理结束-->

                    <!--            身份证框-->
                    <el-form-item v-else-if="item.fieldEng === 'talent_id_card'" :class="{'flex-item': true, 'flex-search': search }" :title="item.fieldName" :label="item.fieldName" :prop="item.fieldEng" :key="item.fieldModelId">
                        <el-input v-model.trim="form[item.fieldEng]" :placeholder="`请输入${item.fieldName}`" clearable :disabled="item.autoGenerate == true" @blur="cardAutoEvent" />
                    </el-form-item>

                    <!--            文本框-->
                    <el-form-item v-else-if="item.fieldInputType == 1" :class="{'flex-item': true, 'flex-search': search }" :title="item.fieldName" :label="item.fieldName" :prop="item.fieldEng" :key="item.fieldModelId">
                        <el-input v-model.trim="form[item.fieldEng]" :placeholder="`请输入${item.fieldName}`" clearable :disabled="item.autoGenerate == true" maxlength="50" :show-word-limit="!search" />
                    </el-form-item>

                    <!--            数字框-->
                    <el-form-item v-else-if="item.fieldInputType == 2" :class="{'flex-item': true, 'flex-search': search }" :title="item.fieldName" :label="item.fieldName" :prop="item.fieldEng" :key="item.fieldModelId">
                        <el-input v-model="form[item.fieldEng]" :placeholder="`请输入${item.fieldName}`" oninput="value = value.replace(/[^\d]/g, '')" clearable :disabled="item.autoGenerate == true" maxlength="11" :show-word-limit="!search" />
                    </el-form-item>

                    <!--            文本域-->
                    <el-form-item v-else-if="item.fieldInputType == 5" :class="{'flex-item': true, 'flex-search': search, 'item-block': true }" :title="item.fieldName" :label="item.fieldName" :prop="item.fieldEng" :key="item.fieldModelId">
                        <el-input v-model.trim="form[item.fieldEng]" type="textarea" :rows="3" :placeholder="`请输入${item.fieldName}`" clearable :disabled="item.autoGenerate == true" maxlength="500" :show-word-limit="!search" />
                    </el-form-item>

                    <!--            下拉框-单选-->
                    <el-form-item v-else-if="item.fieldInputType == 8" :class="{'flex-item': true, 'flex-search': search }" :title="item.fieldName" :label="item.fieldName" :prop="item.fieldEng" :key="item.fieldModelId">
                        <!--        字典项-->
                        <j-dictionary type="select" v-if="item.fieldDicKeyInputFormat == 1" v-model="form[item.fieldEng]" :code="item.fieldDicKey" :api="`/api/dictionaryItems/${item.fieldDicKey}/negot-items`" :placeholder="`请选择${item.fieldName}`" :disabled="item.autoGenerate == true" />
                        <!--        用户管理-->
                        <el-select v-else class="form-w-100" v-model="form[item.fieldEng]" :placeholder="`请选择${item.fieldName}`" clearable filterable :disabled="item.autoGenerate == true">
                            <el-option v-for="item in userDic" :key="item.adminId" :label="item.name" :value="item.adminId" />
                        </el-select>
                    </el-form-item>

                    <!--            下拉框-多选-->
                    <el-form-item v-else-if="item.fieldInputType == 9" :class="{'flex-item': true, 'flex-search': search }" :title="item.fieldName" :label="item.fieldName" :prop="item.fieldEng" :key="item.fieldModelId">
                        <!--        字典项-->
                        <j-dictionary type="select" v-if="item.fieldDicKeyInputFormat == 1" v-model="form[item.fieldEng]" :code="item.fieldDicKey" :api="`/api/dictionaryItems/${item.fieldDicKey}/negot-items`" :placeholder="`请选择${item.fieldName}`" multiple :disabled="item.autoGenerate == true" />
                        <!--        用户管理-->
                        <el-select v-else class="form-w-100" v-model="form[item.fieldEng]" :placeholder="`请选择${item.fieldName}`" multiple clearable filterable :disabled="item.autoGenerate == true">
                            <el-option v-for="item in userDic" :key="item.adminId" :label="item.name" :value="item.adminId" />
                        </el-select>
                    </el-form-item>

                    <!--            单选框-->
                    <el-form-item v-else-if="item.fieldInputType == 6" :class="{'flex-item': true, 'flex-search': search }" :title="item.fieldName" :label="item.fieldName" :prop="item.fieldEng" :key="item.fieldModelId">
                        <!--        字典项-->
                        <j-dictionary v-if="item.fieldDicKeyInputFormat == 1" type="checkbox" v-model="form[item.fieldEng]" :code="item.fieldDicKey" :api="`/api/dictionaryItems/${item.fieldDicKey}/negot-items`" :placeholder="`请选择${item.fieldName}`" :disabled="item.autoGenerate == true" />
                        <!--        用户管理-->
                        <el-radio-group v-else v-model="form[item.fieldEng]" :disabled="item.autoGenerate == true">
                            <el-radio v-for="item in userDic" :key="item.adminId" :label="item.adminId">{{item.name}}</el-radio>
                        </el-radio-group>
                    </el-form-item>

                    <!--            多选框-->
                    <el-form-item v-else-if="item.fieldInputType == 7" :class="{'flex-item': true, 'flex-search': search }" :title="item.fieldName" :label="item.fieldName" :prop="item.fieldEng" :key="item.fieldModelId">
                        <!--        字典项-->
                        <j-dictionary v-if="item.fieldDicKeyInputFormat == 1" type="checkbox" v-model="form[item.fieldEng]" :code="item.fieldDicKey" :api="`/api/dictionaryItems/${item.fieldDicKey}/negot-items`" :placeholder="`请选择${item.fieldName}`" multiple :disabled="item.autoGenerate == true" />
                        <!--        用户管理-->
                        <el-checkbox-group v-else v-model="form[item.fieldEng]" :disabled="item.autoGenerate == true">
                            <el-checkbox v-for="item in userDic" :key="item.adminId" :label="item.adminId">{{item.name}}</el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>

                    <!--            时间范围-->
                    <el-form-item v-else-if="item.fieldInputType == 3" :class="{'flex-item': true, 'flex-search': search, 'item-block': true }" :title="item.fieldName" :label="item.fieldName" :prop="item.fieldEng" :key="item.fieldModelId">
                        <j-date-range v-model="form[item.fieldEng]" :value-format="timeFormat" :disabled="item.autoGenerate == true" />
                    </el-form-item>

                    <!--            范围输入-->
                    <el-form-item v-else-if="item.fieldInputType == 10" :class="{'flex-item': true, 'flex-search': search, 'item-block': true }" :title="item.fieldName" :label="item.fieldName" :prop="item.fieldEng" :key="item.fieldModelId">
                        <j-link-input v-model="form[item.fieldEng]" :disabled="item.autoGenerate == true" />
                    </el-form-item>

                    <!--            时间选择器-->
                    <el-form-item v-else-if="item.fieldInputType == 4" :class="{'flex-item': true, 'flex-search': search }" :title="item.fieldName" :label="item.fieldName" :prop="item.fieldEng" :key="item.fieldModelId">
                        <el-date-picker class="form-w-100" v-model="form[item.fieldEng]" type="date" :placeholder="`请选择${item.fieldName}`" :value-format="timeFormat" :disabled="item.autoGenerate == true" />
                    </el-form-item>

                    <!--            时间时分秒选择器-->
                    <el-form-item v-else-if="item.fieldInputType == 17" :class="{'flex-item': true, 'flex-search': search }" :title="item.fieldName" :label="item.fieldName" :prop="item.fieldEng" :key="item.fieldModelId">
                        <el-date-picker type="datetime" class="form-w-100" v-model="form[item.fieldEng]" :placeholder="`请选择${item.fieldName}`" value-format="yyyy-MM-dd HH:mm:ss" :disabled="item.autoGenerate == true" />
                    </el-form-item>

                    <!--            时间选择器限制今天之前的时间-->
                    <el-form-item v-else-if="item.fieldInputType == 15" :class="{'flex-item': true, 'flex-search': search }" :title="item.fieldName" :label="item.fieldName" :prop="item.fieldEng" :key="item.fieldModelId">
                        <el-date-picker class="form-w-100" v-model="form[item.fieldEng]" type="date" :placeholder="`请选择${item.fieldName}`" :value-format="timeFormat" :picker-options="disabledDateB" :disabled="item.autoGenerate == true" />
                    </el-form-item>

                    <!--            时间选择器限制今天之后的时间-->
                    <el-form-item v-else-if="item.fieldInputType == 14" :class="{'flex-item': true, 'flex-search': search }" :title="item.fieldName" :label="item.fieldName" :prop="item.fieldEng" :key="item.fieldModelId">
                        <el-date-picker class="form-w-100" v-model="form[item.fieldEng]" type="date" :placeholder="`请选择${item.fieldName}`" :value-format="timeFormat" :picker-options="disabledDateA" :disabled="item.autoGenerate == true" />
                    </el-form-item>

                    <!--            地址选择器-->
                    <el-form-item v-else-if="item.fieldInputType == 11" :class="{'flex-item': true, 'flex-search': search, 'item-block': true }" :title="item.fieldName" :label="item.fieldName" :prop="item.fieldEng" :key="item.fieldModelId">
                        <j-address v-model="form[item.fieldEng]" :placeholder="`请选择${item.fieldName}`" value-type="String" :disabled="item.fieldEng === 'household_regist_location_new' || item.autoGenerate == true"  :emitPath="false" />
                    </el-form-item>

                    <!--            所属区划选择器-->
                    <el-form-item v-else-if="item.fieldInputType == 12" :class="{'flex-item': true, 'flex-search': search }" :title="item.fieldName" :label="item.fieldName" :prop="item.fieldEng" :key="item.fieldModelId">
                        <j-grid-ctrl type="select" v-model="form[item.fieldEng]" :placeholder="`请选择${item.fieldName}`" :rule="[6, 9, 12, 14]" :rangeCode="$store.state.user.areaCode" :disabled="item.autoGenerate == true" />
                    </el-form-item>

                    <!--            所属机构选择器-->
                    <el-form-item v-else-if="item.fieldInputType == 13" :class="{'flex-item': true, 'flex-search': search }" :title="item.fieldName" :label="item.fieldName" :prop="item.fieldEng" :key="item.fieldModelId">
                        <el-cascader class="form-w-100" :placeholder="`请选择${item.fieldName}`" v-model="form[item.fieldEng]" :options="$store.state.orgTree" :props="{ emitPath: false, children: 'childs', label: 'orgName', value: 'orgId', checkStrictly: true }" :disabled="item.autoGenerate == true"  />
                    </el-form-item>

                    <!--            上传附件-->
                    <el-form-item v-else-if="item.fieldInputType == 18" :class="{'flex-item': true, 'rule-j-upload': true, 'flex-search': search }" :title="item.fieldName" :label="item.fieldName" :prop="item.fieldEng" :key="item.fieldModelId">
                        <j-upload class="form-w-100" v-model="form[item.fieldEng]" mode="card" :disabled="item.autoGenerate == true" />
                    </el-form-item>

                    <!--            未匹配-->
                    <el-form-item v-else :class="{'flex-item': true, 'flex-search': search }" :title="item.fieldName" :label="item.fieldName" :prop="item.fieldEng" :key="item.fieldModelId">
                        <span class="flex-item-warn">自定义字段:{{ item.fieldName }},未设置类型</span>
                    </el-form-item>
                </template>
            </template>
            <!--        搜索按钮插槽-->
            <el-form-item v-if="search" class="flex-item flex-search search-form-btn">
                <slot></slot>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
    import JGridCtrl from "../../JComponents/JGridCtrl/JGridCtrl";
    import JAddress from '../../JComponents/JAddress/JAddress'
    import JDateRange from '../../JComponents/JDateRange/JDateRange'
    import JLinkInput from '../../JComponents/JLinkInput/JLinkInput'
    import JDictionary from '../../JComponents/JDictionary/JDictionary'
    import JSensitive from '../../JComponents/JSensitive/JSensitive'
    import JUpload from "../../JComponents/JUpload/JUpload";
    import moment from 'moment'
    export default {
        name: 'RuleForm',
        components: {
            JGridCtrl,
            JAddress,
            JDateRange,
            JLinkInput,
            JDictionary,
            JSensitive,
            JUpload
        },
        props: {
            autoFull: {
                type: Boolean,
                default: false
            },
            search: {
                type: Boolean,
                default: false
            },
            readOnly: {
                type: Boolean,
                default: false
            },
            meta: {
                type: Array,
                required: true
            },
            forms: {
                type: Object,
                required: true
            },
            rules: {
                type: Object,
                required: true
            },
            loadDic: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                // 特殊处理校验的字段数组
                praction: ['talent_industry1_praction','talent_industry2_praction','talent_industry3_praction'],
                trailing: ['talent_industry1_trailing','talent_industry2_trailing','talent_industry3_trailing'],
                disabledDateB: { disabledDate: this.disableBefore },
                disabledDateA: { disabledDate: this.disableAfter },
                desensitiveRule: {
                    talent_name: [1],
                    talent_id_card: [1, -1],
                    household_regist_detail_old: [3],
                    household_regist_detail_new: [3]
                },
                userDic: [],
                userMap: {},
                timeFormat: 'yyyy-MM-dd',
                form: {},
                rule: {}
            }
        },
        created() {
            this.loadDic.org && this.$store.dispatch('getOrgTree')
            this.loadDic.user && this.getUserList()
            this.form = { ...this.forms }
            this.rule = { ...this.rules }
            this.autoFull && this.autoFullValue() // 新增时自动生成字段填充
            this.forms['industry'] && this.talentHandle() // 编辑时自动根据industry生成对应规则
        },
        methods: {
            disableBefore (time) {
                return time.getTime() < Date.now() - 8.64e7 // -8.64e7 可以选择今天的时间，没有则不能选
            },
            disableAfter (time) {
                return time.getTime() > Date.now() - 8.64e6 // -8.64e6 可以选择今天的时间，没有则不能选
            },
            autoFullValue() {
                if ('talent_create_org_id' in this.form)
                    this.form['talent_create_org_id'] = this.$store.state.user.orgId
                if ('talent_create_user_id' in this.form)
                    this.form['talent_create_user_id'] = this.$store.state.user.adminId
                if ('talent_create_time' in this.form)
                    this.form['talent_create_time'] = moment().format('yyyy-MM-DD')
            },
            cardAutoEvent() {
                const cardCode = this.form['talent_id_card']
                if (this.$jtool.validate.checkIdCard(cardCode)) {
                    if ('talent_age' in this.form)
                        this.form['talent_age'] = this.$jtool.util.getAgeByCardCode(cardCode)
                    if ('talent_sex' in this.form)
                        this.form['talent_sex'] = this.$jtool.util.getSexByCardCode(cardCode)
                } else {
                    if ('talent_age' in this.form) this.form['talent_age'] = ''
                    if ('talent_sex' in this.form) this.form['talent_sex'] = ''
                }
            },
            talentHandle () {
                this.praction.forEach((key, i) => {
                    this.rule[key][0].required = this.form['industry'] == i + 1 && this.form['employment'] == 'true'
                })
                this.trailing.forEach((key, i) => {
                    this.rule[key][0].required = this.form['industry'] == i + 1 && this.form['employment'] == 'false'
                })
            },
            industryChange () {
                this.form['talent_industry1_praction'] = ''
                this.form['talent_industry2_praction'] = ''
                this.form['talent_industry3_praction'] = ''
                this.form['talent_industry1_trailing'] = ''
                this.form['talent_industry2_trailing'] = ''
                this.form['talent_industry3_trailing'] = ''
                this.$nextTick(() => {
                    this.$refs['ruleDom'].clearValidate()
                })
                this.talentHandle()
            },
            employmentChange(name) {
                if (name === 'employment') {
                    if (this.form['employment'] == 'true') {
                        this.form['country_recruit'] = ''
                        this.form['country_land_auth'] = ''
                        this.form['industry'] = ''
                    } else if (this.form['employment'] == 'false') {
                        this.form['country_recruit'] = 'false'
                        this.form['country_land_auth'] = 'false'
                        this.form['industry'] = ''
                    } else {
                        this.form['country_recruit'] = ''
                        this.form['country_land_auth'] = ''
                        this.form['industry'] = ''
                    }
                }
                if (name === 'country_recruit') {
                    if (this.form['country_recruit'] == 'true') {
                        this.form['country_land_auth'] = 'true'
                        this.form['industry'] = 1
                    } else if (this.form['country_recruit'] == 'false') {
                        this.form['country_land_auth'] = 'false'
                        this.form['industry'] = ''
                    } else {
                        this.form['country_land_auth'] = ''
                        this.form['industry'] = ''
                    }
                }
                this.industryChange()
            },
            validateData() {
                this.$refs['ruleDom'].validate((valid) => {
                    if (valid) {
                        this.$emit('save', this.getFormData())
                    }
                })
            },
            resetFormData() {
                this.$nextTick(() => {
                    this.$refs['ruleDom'].resetFields()
                })
                this.form = { ...this.forms }
            },
            getFormData() {
                // const formData = []
                // this.meta.forEach((field) => {
                //     if (field.fieldOrigin == 0 || field.fieldOrigin == 3) return
                //     const {
                //         fieldDicKey,
                //         fieldDicKeyInputFormat,
                //         fieldEng,
                //         fieldInputType,
                //         fieldModelId,
                //         fieldName,
                //         fieldUniqued,
                //         fieldRequired
                //     } = field
                //     let fieldValue = this.form[fieldEng]
                //     if ([7, 9].includes(fieldInputType)) {
                //         // 多选数组处理
                //         fieldValue = this.form[fieldEng].join(',')
                //     }
                //     if ((fieldRequired && fieldValue !== '' && fieldValue !== undefined && fieldValue !== null) || !fieldRequired) {
                //         formData.push({
                //             fieldDicKey,
                //             fieldDicKeyInputFormat,
                //             fieldEng,
                //             fieldInputType,
                //             fieldModelId,
                //             fieldName,
                //             fieldValue,
                //             fieldUniqued,
                //             fieldRequired
                //         })
                //     }
                // })
                // return formData
                const formObject = {}
                for (let key in this.form) {
                    if (Array.isArray(this.form[key])) {
                        formObject[key] = this.form[key].join(',')
                    } else {
                        formObject[key] = this.form[key]
                    }
                }
                return formObject
            },
            async getUserList() {
                const { data } = await this.$http.get(`/api/admins`, {
                    params: { page: 1, limit: 900 }
                })
                this.userDic = data.data.data || []
                this.userDic.forEach((item) => {
                    this.userMap[item.adminId] = item.name
                })
            }
        }
    }
</script>

<style lang="scss">
    .rule-form {
        &:empty {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            height: 150px;
            &:after {
                content: '未配置字段';
                font-size: 14px;
                font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
                font-weight: normal;
                color: rgba(21,24,30,0.75);
                line-height: 20px;
            }
            &:before {
                content: '';
                width: 80px;
                height: 80px;
                background-image: url("../../../assets/ruleForm/empty.png");
                background-size: cover;
                margin-bottom: 12px;
            }
        }

        display: flex;
        flex-wrap: wrap;
        /*justify-content: space-between;*/
        align-items: flex-start;
        &.rule-form-search {
            justify-content: flex-start;
        }
        &.rule-form-readonly {
            /deep/ .el-form-item--small.el-form-item {
                margin-bottom: 10px !important;
            }
        }
    }
    .flex-item-text {
        font-size: 14px;
        font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
        font-weight: normal;
        color: #15181E;
        line-height: 16px;
        &:empty {
            &::before {
                content: "-";
                color: #141c25;
            }
        }

        .flex-item-text-item {
            + .flex-item-text-item {
                margin-left: 5px;
            }
        }
    }
    .el-form-item--small.el-form-item {
        margin-bottom: 12px;
    }
    .rule-form-title {
        position: relative;
        width: 100%;
        margin-bottom: 10px;
        padding: 6px 0 6px 12px;
        box-sizing: border-box;
        background-color: transparent!important;
        border-radius: 4px;
        font-size: 14px;
        font-family: Alibaba-PuHuiTi-M, Alibaba-PuHuiTi;
        font-weight: normal;
        color: #141c25;
        line-height: 20px;
        .el-form-item__content {
            line-height: 20px !important;
        }
        &:not(:nth-of-type(1)) {
            margin-top: 4px;
        }
        &::before {
            content: "";
            height: 8px;
            width: 4px;
            background: #275da6;
            position: absolute;
            top: 50%;
            left: 0;
            transform: translateY(-50%);
        }
    }
    .form-w-100 {
        width: 100% !important;
    }
    .flex-item {
        display: flex;
        padding: 2px 4px 2px 12px;
        border-radius: 8px;
        /*background-color: #f9fafb;*/
        box-sizing: border-box;
        width: 100%;
        margin-bottom: 12px !important;
        &.rule-j-upload {
            .el-form-item__label {
                margin-right: 5px;
            }
        }
        &.search-form-btn {
            padding: 0px 4px 0px 0px;
            background-color: transparent;
        }
        &.flex-search {
            margin-right: 16px;
        }
        &.read-only {
            padding: 8px 10px 8px 0;
            display: inline-flex;
            /*width: 30%;*/
            background-color: transparent;
            margin-bottom: 0 !important;
            box-sizing: content-box;
            .el-form-item__content {
                line-height: 16px;
                display: flex;
                justify-content: flex-end;
            }
            .el-form-item__label {
                height: auto;
                max-width: 85px;
                width: auto;
                text-align: left;
                font-size: 14px;
                font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
                font-weight: normal;
                color: rgba(21, 24, 30, 0.5);
                padding: 0 10px 0 0;
                line-height: 16px;
                &::before {
                    display: none;
                }
                &::after {
                    display: none;
                }
            }
        }
        .flex-item-warn {
            display: inline-flex;
            margin-left: 8px;
            font-size: 14px;
            font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
            font-weight: normal;
            color: #ff6300;
            line-height: 20px;
        }
        &.item-block {
            width: 100%;
            /*max-width: 500px;*/
        }
        &.item-empty {
            height: 37px;
            box-sizing: border-box;
            background-color: transparent !important;
        }
        .el-form-item__label {
            position: relative;
            width: 100px;
            /*padding: 0 8px 0 0;*/
            box-sizing: border-box;
            overflow: hidden;
            text-overflow: ellipsis;
            word-break: keep-all;
            white-space: nowrap;
            /*&::before {*/
            /*  color: #ff6300 !important;*/
            /*}*/
            /*&::after {*/
            /*  content: "";*/
            /*  height: 12px;*/
            /*  width: 1px;*/
            /*  background: #d8dce3;*/
            /*  position: absolute;*/
            /*  top: 10px;*/
            /*  right: 0px;*/
            /*}*/
        }
        .el-form-item__content {
            flex: 1;
            font-size: 14px;
            font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
            color: #141c25;
        }

        /*.el-radio-group,*/
        /*.el-checkbox-group {*/
        /*  margin-left: 8px;*/
        /*}*/
        /*.el-checkbox-group {*/
        /*  display: flex;*/
        /*  flex-wrap: wrap;*/
        /*}*/
        /*.el-radio {*/
        /*  margin: 4px 30px 4px 0;*/
        /*}*/
        /*.is-disabled {*/
        /*  .el-input__inner,*/
        /*  .el-textarea__inner {*/
        /*    color: rgba(#141c25, 0.55);*/
        /*  }*/
        /*  .el-date-editor--daterange {*/
        /*    .el-range-input {*/
        /*      color: rgba(#141c25, 0.55);*/
        /*    }*/
        /*  }*/
        /*  .el-radio__input.is-disabled + span.el-radio__label {*/
        /*    color: rgba(#141c25, 0.55);*/
        /*  }*/
        /*  .j-link-input-wrap {*/
        /*    .el-input__inner,*/
        /*    .el-textarea__inner {*/
        /*      color: rgba(#141c25, 0.55);*/
        /*    }*/
        /*  }*/
        /*}*/
        /*.el-input__inner,*/
        /*.el-textarea__inner {*/
        /*  color: #141c25;*/
        /*  font-size: 14px;*/
        /*  border-color: transparent !important;*/
        /*  background-color: transparent !important;*/
        /*  &::placeholder {*/
        /*    color: rgba(#141c25, 0.35);*/
        /*  }*/
        /*}*/
        /*.el-date-editor--daterange {*/
        /*  width: 100%;*/
        /*  .el-range-input {*/
        /*    !*background-color: #EEF2F8!important;*!*/
        /*    background-color: transparent !important;*/
        /*    color: #141c25;*/
        /*    font-size: 14px;*/
        /*    border-radius: 4px;*/
        /*    &::placeholder {*/
        /*      color: rgba(#141c25, 0.35);*/
        /*    }*/
        /*  }*/
        /*}*/
        /*.j-link-input-wrap {*/
        /*  margin-left: 10px;*/
        /*  .el-input__inner,*/
        /*  .el-textarea__inner {*/
        /*    color: #141c25;*/
        /*    font-size: 14px;*/
        /*    &::placeholder {*/
        /*      color: rgba(#141c25, 0.35);*/
        /*    }*/
        /*    !*background-color: #EEF2F8!important;*!*/
        /*    !*border-radius: 4px;*!*/
        /*    !*height: 24px;*!*/
        /*    !*line-height: 24px;*!*/
        /*  }*/
        /*}*/
    }
</style>
